import { Button, Text, Card, Image } from '@mantine/core';
import { modals } from '@mantine/modals';
import { IconExternalLink } from '@tabler/icons-react';
import { useProjectId } from '~/hooks/context/useProjectId';

export default function IntegrationStatusDialog() {
  const projectId = useProjectId();

  return (
    <div className="flex flex-col space-y-4">
      <Text
        size="sm"
        c="dimmed"
      >
        Connect an issue tracker to create and link issues directly from test failures.
      </Text>

      <div className="flex flex-col gap-4">
        <Card
          withBorder
          padding="md"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="flex h-6 w-6 items-center justify-center rounded bg-gray-900">
                <Image
                  src="/assets/linear-light-logo.svg"
                  alt="Linear logo"
                  className="h-5 w-5"
                />
              </div>
              <div>
                <Text fw={500}>Linear</Text>
                <Text
                  size="sm"
                  c="dimmed"
                >
                  Create issues directly in Linear
                </Text>
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              rightSection={<IconExternalLink size={14} />}
              onClick={() => {
                window.open(`/project/${projectId}/integrations`, '_blank');
                modals.closeAll();
              }}
            >
              Connect
            </Button>
          </div>
        </Card>

        <Card
          withBorder
          padding="md"
          opacity={0.6}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Image
                src="/assets/jira-logo.svg"
                alt="Jira logo"
                className="h-6 w-6"
              />
              <div>
                <Text fw={500}>Jira</Text>
                <Text
                  size="sm"
                  c="dimmed"
                >
                  Coming soon
                </Text>
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              disabled
            >
              Coming Soon
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
